import { Button, Stack, Text } from '../ui';
import { readAuthConfig } from './config';
import { useAuth } from './AuthProvider';

/**
 * The header's sign-in status and action.
 *
 * In development mode the identity is fixed by configuration, so it shows the name only — a sign-out
 * would be a confusing no-op. In `entraExternalId` mode it shows the signed-in name with a sign-out
 * action, or a "Sign in" action when signed out, so sign-in is reachable without first hitting a
 * gated route.
 *
 * @returns The user menu element, or `null` when there is nothing to show.
 */
export function UserMenu(): React.JSX.Element | null {
  const { status, user, signIn, signOut } = useAuth();
  const { mode } = readAuthConfig();

  if (mode !== 'entraExternalId') {
    return user?.name !== undefined ? (
      <Text size="sm" muted>
        {user.name}
      </Text>
    ) : null;
  }

  if (status === 'authenticated') {
    return (
      <Stack direction="row" gap="sm" align="center">
        {user?.name !== undefined ? (
          <Text size="sm" muted>
            {user.name}
          </Text>
        ) : null}
        <Button onClick={signOut}>Sign out</Button>
      </Stack>
    );
  }

  if (status === 'unauthenticated') {
    return (
      <Button variant="primary" onClick={() => signIn()}>
        Sign in
      </Button>
    );
  }

  return null;
}
